import { useMutation } from 'react-query';
import { updateRegisterResultProduct } from 'apis/registerResult';

const useMutationUpdateRegisterResultProduct = () => {
  const { mutateAsync, ...rest } = useMutation(updateRegisterResultProduct);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationUpdateRegisterResultProduct;
